import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../core/shared-service/grid-utils';

class listCommunitiesCtrl {
    /*  @ngInject */
    constructor($state, logger, AuthSvc, $uibModal, CommunitySvc, $scope) {
        this.$state = $state;
        this.logger = logger;
        this.AuthSvc = AuthSvc;
        this.$uibModal = $uibModal;
        this.CommunitySvc = CommunitySvc;
        this.$scope = $scope;
    }

    $onInit() {
        this.getAllCommunities();

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="community.details.main({ eid : row.entity.eid })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'eid',
                    displayName: 'Id communauté',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'defaultcursor',
                },
                {
                    name: 'name',
                    displayName: 'Nom communauté',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'defaultcursor',
                },
                {
                    name: 'alias',
                    displayName: 'Raison sociale',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'defaultcursor',
                },
                {
                    name: 'creationDate',
                    displayName: 'Date de création',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'defaultcursor',
                    cellFilter: "date:'short'",
                },
            ],
            exporterOlderExcelCompatibility: true,
            useExternalPagination: true,
            useExternalSorting: true,
            onRowClicked: this.myRowClickedHandler,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
                // Sorting & pagination
                gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => {
                    sortColumns = _.map(sortColumns, col => this.convertSort(col));
                    if (sortColumns && sortColumns.length > 0) {
                        this.searchData.setSort(sortColumns);
                    } else {
                        this.searchData.resetSort();
                    }
                    this.search();
                });
                gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => {
                    this.getAllCommunities((page - 1), size);
                });
            },
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
        };
    }

    getAllCommunities(page = 0, size = 20) {
        this.containerPromise = this.CommunitySvc.getAllCommunities(page, size);
        this.containerPromise.then(
            data => {
                this.gridOptions.data = data.content;
                this.gridOptions.totalItems = data.totalElements
            },
            () => {
                this.logger.error('error.search');
            }
        );
    }
    getGridHeight() {
        return gridHeight(this.gridApi);
    }

    isAuthorizedToCreate() {
        return this.AuthSvc.isAuthorized('CONFIGURATOR');
    }

    newCommunity() {
        this.$state.go('community.new.create');
    }

    openImport() {
        this.$uibModal
            .open({
                component: 'modalImportCommunityMemership',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
            })
            .result.then({}, {});
    }

    convertSort(col) {
        var columnField = _.find(this.KISS_INVOICE.columnFieldMap, { field: col.field });
        if (col && col.sort) {
            return {
                direction: angular.uppercase(col.sort.direction),
                property: columnField ? columnField.property : col.field,
                priority: col.sort.priority,
            };
        }
        return {};
    }
}

angular.module('app.community').component('listCommunities', {
    templateUrl: require('./list-communities.html'),
    controller: listCommunitiesCtrl,
    bindings: {},
});
